import { Component, OnInit } from '@angular/core';
import { Order } from './model/order';
import { Batch } from './model/extraction-batch';
import { ExtractionService } from './extraction.service';
import { forkJoin } from 'rxjs';
import { MasterDataService } from '../masterdata/masterdata.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import rfdc from 'rfdc';
import { KitLot } from './model/kitlot';
import { NGSSample } from './model/ngs-sample';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-extraction',
  templateUrl: './extraction.component.html',
  styleUrls: ['./extraction.component.css']
})
export class ExtractionComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  orderTableCols: any[];
  fieldsForSearch : any[];
  selectedSearchField: string;
  batchTableCols: any[];
  searchValue: string;
  orderTableLoading = false;
  batchTableLoading = false;
  orders: Order[] = []
  batches: Batch[] = [];  
  selectedLabId: string;
  puid: string;
  newInitials: string;
  selectedBatch: Batch;
  selectedBatchBackup: Batch;
  blocked = false;
  dateTimeFormat: string;
  extractionKits: any[] = []
  extrationKitMaterialMap = new Map();
  selectedExtractionKit: string;
  kitLotPopUpVisible = false;
  reagents: KitLot[];
  atLeastOneLotNumberFilled = false;
  clone = rfdc();

  readonly BATCH_CREATED = 'BATCH_CREATED';
  readonly columnHeaders = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  readonly rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  readonly allPositionListVertical = [
                                        'A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 
                                        'A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2', 'H2', 
                                        'A3', 'B3', 'C3', 'D3', 'E3', 'F3', 'G3', 'H3', 
                                        'A4', 'B4', 'C4', 'D4', 'E4', 'F4', 'G4', 'H4', 
                                        'A5', 'B5', 'C5', 'D5', 'E5', 'F5', 'G5', 'H5', 
                                        'A6', 'B6', 'C6', 'D6', 'E6', 'F6', 'G6', 'H6', 
                                        'A7', 'B7', 'C7', 'D7', 'E7', 'F7', 'G7', 'H7', 
                                        'A8', 'B8', 'C8', 'D8', 'E8', 'F8', 'G8', 'H8', 
                                        'A9', 'B9', 'C9', 'D9', 'E9', 'F9', 'G9', 'H9', 
                                        'A10', 'B10', 'C10', 'D10', 'E10', 'F10', 'G10', 'H10', 
                                        'A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 
                                        'A12', 'B12', 'C12', 'D12', 'E12', 'F12', 'G12', 'H12'
                                      ];
  readonly allPositionListHorizontal = [
                                        'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 
                                        'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'B11', 'B12',
                                        'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11', 'C12',
                                        'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12',
                                        'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7', 'E8', 'E9', 'E10', 'E11', 'E12',
                                        'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12',
                                        'G1', 'G2', 'G3', 'G4', 'G5', 'G6', 'G7', 'G8', 'G9', 'G10', 'G11', 'G12',
                                        'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8', 'H9', 'H10', 'H11', 'H12'
                                      ];
  readonly BATCH_COMPLETE = 'BATCH_COMPLETE';

  scannedBarcode: string = null;
  previousScannedBarcode: string = null;
  plate: Map<string, NGSSample> = new Map<string, NGSSample>();
  scanOperationStarted: boolean = false;
  removeOperationStarted: boolean = false;
  noMoreSpaceOnPlate: boolean = false;
  currentPosition: string = null;
  verticalOrientation: boolean = true;
  orderAdditionTrackerMap: Map<string, boolean> = new Map<string, boolean>();
  removeTrackerMap: Map<string, boolean> = new Map<string, boolean>();
  commentStr: string = null
  plateSampleTracker: Map<string, string>  = new Map<string, string>();
  orderCommentsMap: Map<string, string> = new Map<string, string>();

  showExtractionCompletedBatches: boolean = false;
  scheduledFromDate: Date;
  scheduledToDate: Date;

  constructor(private extractionService: ExtractionService, 
    private masterDataServcie: MasterDataService, 
    private _messagesService: MessagesService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');
    this.orderTableCols = [
      { field: 'orderNumber', header: 'Project', width:'25%' },
      { field: 'sampleCountInOrder', header: 'Count', width:'15%' },
      { field: "libraryType", header: 'Library Type',width:'25%' },
      { field: 'sampleSource', header: 'Source',width:'25%' },
      { field: 'orderAdder', header: '', width:'10%' },
    ]

    this.batchTableCols = [
      { field: 'batchId', header: 'Batch ID', width:'30%' },
      { field: 'status', header: 'Status', width:'40%' },
      { field: "count", header: 'Count', width:'30%' }
    ]

    this.fieldsForSearch = [
      {label:'Batch Id',value:'batchId'},
      {label:'Sample Barcode',value:'barcode'},
      {label:'Project Id',value:'orderId'},
      {label:'Library Type',value:'libraryType'}
    ];

    this.selectedSearchField = 'batchId';
    this.dateTimeFormat =  JSON.parse(localStorage.getItem('lab')).lab.dateTimeFormat;
    this.loadOrdersAndBatches()
    this.loadExtractionKits()
  }
  
  loadOrdersAndBatches() {

    this.orderTableLoading = true;
    this.batchTableLoading = true;
    let orders$ = this.extractionService.getOrdersEligibleForExtraction(this.selectedLabId);
    let batches$ = this.extractionService.getBatchesEligibleForExtraction(this.selectedLabId, "", null, null);

    forkJoin([orders$, batches$]).subscribe(results=>{
      this.orderTableLoading = false;
      this.batchTableLoading = false;
      if(results[0].data){
        this.orders = results[0].data;
      }
      if(results[1].data) {
        this.batches = results[1].data;
      }
    }, error =>{
      this.orderTableLoading = false;
      this.batchTableLoading = false;
      this.handleError(error);
    });
  }
  
  loadExtractionKits() {
    this.blocked = true;
    this.masterDataServcie.getSenderSpecificKits(this.selectedLabId, true).subscribe(
      result=>{
        this.blocked = false;
        if(result.data?.extraction) {
          result.data.extraction.forEach(eachKit => {
            this.extractionKits.push({label: eachKit.kitName, value:eachKit.kitName});

            this.extrationKitMaterialMap.set(eachKit.kitName, eachKit.requiredMaterials.split(","));
          });
        }
      },
      error => {
        this.handleError(error);
      }
    )
  }

  createNewBatch(createNewBatch: any) {
    if(this.scanOperationStarted || this.removeOperationStarted) {
      this.confirmationService.confirm({
        message: 'Plate currently has unsaved changes. Are you sure you want to continue?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.createNewBatchOperation(createNewBatch);
        },
        reject: () => {
          createNewBatch.hide();
        }
      });
    } else {
      this.createNewBatchOperation(createNewBatch);
    }
  }

  createNewBatchOperation(createNewBatch: any) {
    this.blocked = true;
    this.extractionService.createBatch(this.selectedLabId, this.newInitials, this.puid).subscribe(
      result=>{
        this.blocked = false;
        this.selectedBatch = result.data;
        this.selectedBatchBackup = this.clone(this.selectedBatch);
        this.resetPlateView();
        this.currentPosition = 'A1';
        setTimeout(() => {
          document.getElementById("barcode-scan").focus();
        }, 50);
        this.newInitials = null;
        createNewBatch.hide();
        this._messagesService.addSuccessMessage({
          severity:'success', summary:'Batch created with Batch ID: ' + this.selectedBatch.batchId, detail:''
        })
        this.batchTableLoading = true;
        this.reloadBatches();
      }, error=>{
        this.blocked = false;
        this.handleError(error);
      }
    )
  }

  searchBatch(serachValue: string, searchField: string) {
    if(this.scanOperationStarted || this.removeOperationStarted) {
      this.confirmationService.confirm({
        message: 'Plate currently has unsaved changes. Are you sure you want to continue?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.searchBatchOperation(serachValue, searchField);
        },
        reject: () => {
          this.selectedBatch = this.clone(this.selectedBatchBackup);
        }
      });
    } else {
      this.searchBatchOperation(serachValue, searchField);
    }
  }

  searchBatchOperation(serachValue: string, searchField: string){
    this.blocked = true;
    this.extractionService.searchBatchUsingField(this.selectedLabId, searchField, serachValue).subscribe(
      result => {
        this.blocked = false;
        this.selectedBatch = result.data;
        this.selectedBatchBackup = this.clone(this.selectedBatch);
        this.selectedExtractionKit = this.selectedBatch.extractionKit;
        if(this.selectedBatch.reagents){
          this.reagents = this.clone(this.selectedBatch.reagents)
          this.checkIfAtLeastOneLotNumberFilled()
        }
        this.loadPlateWithBatchSamples();
      }, error => {
        this.blocked = false;
        this.handleError(error);
      }
    )
  }

  clearPlate() {
    if(this.scanOperationStarted || this.removeOperationStarted) {
      this.confirmationService.confirm({
        message: 'Plate currently has unsaved changes. Are you sure you want to continue?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.selectedBatch  = null;
          this.selectedBatchBackup = null;
          this.resetPlateView();
        },
        reject: () => {
          this.selectedBatch = this.clone(this.selectedBatchBackup);
        }
      });
    } else {
      this.resetPlateView();
      this.selectedBatch = null;
      this.selectedBatchBackup = null;
    }
  }

  loadPlateWithBatchSamples() {
    this.resetPlateView();
    if(this.selectedBatch.sampleDetails && this.selectedBatch.sampleDetails.length > 0) {
      // Initialization of plate map
      // Intializing first plate to scan
      this.selectedBatch.sampleDetails.forEach(sample => {
        let sampleComment = sample.orderComment;
          if(sampleComment && sampleComment.trim() != '') {
            this.orderCommentsMap.set(sample.orderNumber, sample.orderComment);
        }
        sample.savedSample = true;
        this.plateSampleTracker.set(sample.sampleBarcode, sample.wellPosition);
        this.plate.set(sample.wellPosition, sample);
      });
    }
    this.findFirstEmptyPos();
  }

  findFirstEmptyPos() {
    this.currentPosition = null;
    this.verticalOrientation = (this.selectedBatch.verticalOrientation == null || this.selectedBatch.verticalOrientation == undefined) ? true : this.selectedBatch.verticalOrientation;
    let positionList = this.verticalOrientation ? this.allPositionListVertical : this.allPositionListHorizontal;
    for(let pos of positionList) {
      if(!this.plate.has(pos)) {
        this.currentPosition = pos;
        break;
      }
    }
    if(this.currentPosition) {
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
    }
  }

  reloadOrders(){
    this.orderTableLoading = true;
    this.extractionService.getOrdersEligibleForExtraction(this.selectedLabId).subscribe(
      result=>{
        this.orderTableLoading = false;
        this.orders = result.data
      }, error=>{
        this.orderTableLoading = false;
        this.handleError(error);
      }
    )
  }

  reloadBatches(){
    this.batchTableLoading = true;
    this.showExtractionCompletedBatches = false;
    this.extractionService.getBatchesEligibleForExtraction(this.selectedLabId, "", null, null).subscribe(
      result=>{
        this.batchTableLoading = false;
        this.batches = result.data
      }, error=>{
        this.batchTableLoading = false;
        this.handleError(error);
      }
    )
  }

  searchKeyword(){
    if(!this.searchValue || this.searchValue?.trim() == ''){
      this._messagesService.addErrorMessage({
        severity:'error', summary:'Invalid Search!', detail:'Please enter valid value without spaces to search'
      })
      return;
    }

    if(this.selectedSearchField == 'orderId' || this.selectedSearchField == 'libraryType') {
      this.orderTableLoading = true;
      this.batchTableLoading = true;
      this.extractionService.searchOrder(this.selectedLabId, this.selectedSearchField, this.searchValue).subscribe(
        result=>{
          this.orderTableLoading = false;
          this.batchTableLoading = false;
          this.orders = result.data.extractionOrderDetails
          this.batches = result.data.batchData;
        }, error=>{
          this.orderTableLoading = false;
          this.batchTableLoading = false;
          this.handleError(error)
        }
      )

    } else {
      this.searchBatch(this.searchValue, this.selectedSearchField);
    }
  }

  toggleCommentOverlay(event: any, commentOverlay: any) {
    if(this.orderCommentsMap.size != 0) {
      commentOverlay.toggle(event)
    }
  }

  showKitLotPopUp(){
    if(!this.selectedBatch.reagents) {
      this.reagents= [];
      let reagents = this.extrationKitMaterialMap.get(this.selectedExtractionKit);
      reagents.forEach(reagent => {
        let kitLot = new KitLot();

        kitLot.reagent = reagent;
        kitLot.lot = ''

        this.reagents.push(kitLot)
      });
    } else {
      this.reagents = this.clone(this.selectedBatch.reagents)
    }
    this.kitLotPopUpVisible = true;
  }

  saveReagents(){
    this.selectedBatch.reagents = this.clone(this.reagents);
    this.checkIfAtLeastOneLotNumberFilled();
    this.saveBatch();
  }
  checkIfAtLeastOneLotNumberFilled() {
    this.atLeastOneLotNumberFilled = this.reagents.some(reagent=> reagent.lot != '')
  }

  addReagent(index: number, reagent:string) {
    let newReagent = new KitLot();
    newReagent.reagent = reagent;
    newReagent.lot = '';

    this.reagents.splice(index + 1, 0, newReagent)
  }

  completeBatch() {
    this.selectedBatch.extractionKit = this.selectedExtractionKit;
    this.selectedBatch.completionDate = new Date();
    this.selectedBatch.completionPUID = this.puid;
    this.selectedBatch.status = this.BATCH_COMPLETE;
    this.saveBatch();
  }

  startExtraction() {
    this.selectedBatch.startExtractionDate = new Date();
    this.selectedBatch.startExtractionPUID = this.puid;
    this.selectedBatch.status = 'EXTRACTION_START';
    this.saveBatch();
  }

  completeExtraction() {
    this.selectedBatch.completeExtractionDate = new Date();
    this.selectedBatch.completeExtractionPUID = this.puid;
    this.selectedBatch.status = 'EXTRACTION_COMPLETE';
    this.saveBatch();
  }

  saveBatch() {
   this.blocked = true;
   this.extractionService.updateBatch(this.selectedBatch).subscribe(
    result=>{
      this.blocked = false;
      this.selectedBatch = result.data;
      this._messagesService.addSuccessMessage({
        severity:'success', summary:'Batch Saved Successfully',detail:''
      })
      this.reloadBatches();
      this.kitLotPopUpVisible = false;
    }, error=>{
      this.blocked = false
      this.handleError(error)
    }
   )
  }

  handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getSampleDetailFromMap(row: string, col: string, field: string) {
    let position = row + col;
    if(this.plate.has(position)) {
      return this.plate.get(position)[field];
    } else {
      return null;
    }
  }

  hideOrderAdder(order: Order) {
    return (!this.selectedBatch || this.plate.size == 96 || this.orderAdditionTrackerMap.has(order.orderNumber) || this.selectedBatch.status != this.BATCH_CREATED || this.removeOperationStarted || !order.rgcAvailable) ;
  }
  getSampleName(barcode,order){
    return order.sampleDetails[barcode]?.sampleName ?? ""
  }

  addOrderSamplesToPlate(order: Order) {
    let positionalArray = this.verticalOrientation ? this.allPositionListVertical : this.allPositionListHorizontal;
    if(this.plate.has(this.currentPosition)) {
      this.currentPosition = this.findNextEmptyPosition(positionalArray);
    }

    let sampleBarcodes = order.sampleBarcodes;
    sampleBarcodes.sort((sample1Barcode,sample2Barcode)=> this.getSampleName(sample1Barcode,order).localeCompare
          (this.getSampleName(sample2Barcode,order), 'en', { numeric: true }))

    let currentPosIndex = this.currentPosition ? positionalArray.indexOf(this.currentPosition) : 0;
    let barcodesLen = order.sampleBarcodes.length;
    let j = 0;
    for(let i = currentPosIndex; i < positionalArray.length && j < barcodesLen ; i++) {
      if(!this.plate.has(positionalArray[i])) {
        if(!this.plateSampleTracker.has(sampleBarcodes[j])) {
          let sample = new NGSSample();
          let sampleDetails = order.sampleDetails[sampleBarcodes[j]];
          sample.sampleBarcode = sampleBarcodes[j];
          sample.orderNumber = order.orderNumber;
          sample.sampleSource = sampleDetails ? sampleDetails.sampleSource : null;
          sample.stepComment = sampleDetails ? sampleDetails.stepComment : null;
          sample.libraryType = sampleDetails ? sampleDetails.libraryType : null;
          sample.orderComment = order.orderComment;
          sample.sampleName = sampleDetails?.sampleName;
          sample.gxp = order.gxp;
          this.plate.set(positionalArray[i], sample);
          this.plateSampleTracker.set(sample.sampleBarcode, positionalArray[i]);
          this.orderCommentsMap.set(sample.orderNumber, sample.orderComment);
          this.scanOperationStarted = true;
          this.currentPosition = positionalArray[i];
        } else {
          i--;
        }
        j++;
      } 
    }
    if(this.plate.size != 96 && j < barcodesLen) {
      for(let i = 0; i < currentPosIndex && j < barcodesLen; i++) {
        if(!this.plate.has(positionalArray[i])) {
          if(!this.plateSampleTracker.has(sampleBarcodes[j])) {
            let sample = new NGSSample();
            let sampleDetails = order.sampleDetails[sampleBarcodes[j]];
            sample.sampleBarcode = sampleBarcodes[j];
            sample.orderNumber = order.orderNumber;
            sample.sampleSource = sampleDetails ? sampleDetails.sampleSource : null;
            sample.stepComment = sampleDetails ? sampleDetails.stepComment : null;
            sample.libraryType = sampleDetails ? sampleDetails.libraryType : null;
            sample.sampleName = sampleDetails?.sampleName;
            sample.orderComment = order.orderComment;
            this.plate.set(positionalArray[i], sample);
            this.plateSampleTracker.set(sample.sampleBarcode, positionalArray[i]);
            this.orderCommentsMap.set(sample.orderNumber, sample.orderComment);
            this.scanOperationStarted = true;
            this.currentPosition = positionalArray[i];
          } else {
            i--;
          }
          j++;
        }
      }
    }
    if(j > 0) {
      this.orderAdditionTrackerMap.set(order.orderNumber, true);
    }
    this.currentPosition = this.findNextEmptyPosition(positionalArray);
    if(this.currentPosition) {
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
    }
  }

  moveToNextEmptyCell() {
    let positionalArray = this.verticalOrientation ? this.allPositionListVertical : this.allPositionListHorizontal;
    if(this.plate.size == 96) {
      this.currentPosition = null;
    } else {
      this.currentPosition = this.findNextEmptyPosition(positionalArray);
    }
  }

  findNextEmptyPosition(positionalArray: string[]) {
    let emptyPos = null;
    let currentPosIndex = this.currentPosition ? positionalArray.indexOf(this.currentPosition) : -1;
    for(let i = currentPosIndex + 1; i < positionalArray.length; i++) {
      if(!this.plate.has(positionalArray[i])) {
        emptyPos = positionalArray[i];
        break;
      }
    }
    if(!emptyPos) {
      for(let i = 0; i < currentPosIndex; i++) {
        if(!this.plate.has(positionalArray[i])) {
          emptyPos = positionalArray[i];
          break;
        }
      }
    }
    return emptyPos;
  }
  
  cellClickHandler(row: string, col: string, stepCommentOverlay: any, event: any) {
    if(!this.selectedBatch) {
      return;
    }

    let position = row + col;
    if(this.removeOperationStarted) {
      if(this.removeTrackerMap.has(position)) {
        this.removeTrackerMap.delete(position)
      } else if(this.plate.has(position)) {
        this.removeTrackerMap.set(position, true);
      }
      this.currentPosition = position;
    } else if(position == this.currentPosition && this.plate.has(position)) {
      this.commentStr = this.plate.get(position).stepComment;
      stepCommentOverlay.toggle(event);
    } else if(position == this.currentPosition && !this.plate.has(position)) {
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
    } else if(position != this.currentPosition && !this.plate.has(position)) {
      this.currentPosition = position;
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
    } else {
      this.currentPosition = position;

    }
  }

  scanNotAllowed() {
    return (!this.selectedBatch || this.selectedBatch.status == this.BATCH_CREATED || this.removeOperationStarted || this.plate.has(this.currentPosition));
  }

  scanSamples() {

    if(this.plateSampleTracker.has(this.scannedBarcode)) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Sample already preset in plate at: ' + this.plateSampleTracker.get(this.scannedBarcode)});
      this.scannedBarcode = null;
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
      return;
    }
    
    this.extractionService.validateBarcode(this.selectedLabId, this.scannedBarcode).subscribe(
      result => {
        this.scanOperationStarted = true;
        this.plateSampleTracker.set(this.scannedBarcode, this.currentPosition);
        this.previousScannedBarcode = this.scannedBarcode;
        this.scannedBarcode = null;
        let sample: NGSSample = result.data;
        this.orderCommentsMap.set(sample.orderNumber, sample.orderComment);
        this.plate.set(this.currentPosition, sample);
        this.moveToNextEmptyCell();
        setTimeout(() => {
          document.getElementById("barcode-scan").focus();
        }, 50);
      },
      error => {
        this.handleError(error);
        this.scannedBarcode = null;
        setTimeout(() => {
          document.getElementById("barcode-scan").focus();
        }, 50);
      }
    );
  }
  
  saveScan() {
    this.selectedBatch.verticalOrientation = this.verticalOrientation;
    this.selectedBatch.sampleBarcodes = [];
    this.selectedBatch.sampleDetails = [];

    for(let key of this.plate.keys()) {
      let sample = this.plate.get(key);
      this.selectedBatch.sampleBarcodes.push(sample.sampleBarcode);
      if(!sample.savedSample) {
        sample.wellPosition = key;
        this.selectedBatch.sampleDetails.push(sample);
      }
      if(sample.gxp) {
        this.selectedBatch.gxp = true;
      }
    }
    this.blocked = true;
    this.extractionService.scanSave(this.selectedBatch).subscribe(
      result => {
        this.blocked = false;
        this.selectedBatch = result.data;
        this.selectedBatchBackup = this.clone(this.selectedBatch);
        this.loadPlateWithBatchSamples();
        this.reloadOrders();
        this.reloadBatches();
        this._messagesService.addSuccessMessage({severity: 'success', summary: 'All scanned samples saved successfully!'});
      },
      error => {
        this.handleError(error);
        this.selectedBatch = this.clone(this.selectedBatchBackup);
      }
    );
  }

  resetPlateView() {
    this.currentPosition = null;
    this.scanOperationStarted = false;
    this.removeOperationStarted = false;
    this.noMoreSpaceOnPlate = false;
    this.verticalOrientation = true;
    this.plate = new Map<string, NGSSample>();
    this.orderAdditionTrackerMap = new Map<string, boolean>();
    this.removeTrackerMap = new Map<string, boolean>();
    this.plateSampleTracker = new Map<string, string>();
    this.orderCommentsMap = new Map<string, string>();
    this.commentStr = null;
    this.scannedBarcode = null;
    this.previousScannedBarcode = null;
  }

  disableRemoveButton() {
    return (!this.selectedBatch || !this.plate || this.plate.size == 0 || this.removeOperationStarted || this.selectedBatch.status != this.BATCH_CREATED);
  }

  disableRemoveConfirmButton() {
    return (this.removeTrackerMap.size == 0);
  }

  onRemoveButtonClick() {
    if(!this.selectedBatch) {
      return;
    }
    this.removeOperationStarted = true;
  }

  removeSamples() {
    let barcodeMap = new Map<string, boolean>();
    if(!this.selectedBatch.removedBarcodes) {
      this.selectedBatch.removedBarcodes = [];
    }

    for(let key of this.removeTrackerMap.keys()) {
      let sample = this.plate.get(key);
      if(sample.savedSample) {
        this.selectedBatch.removedBarcodes.push(sample.sampleBarcode);
      } 
      barcodeMap.set(sample.sampleBarcode, true);
    }

    if(this.selectedBatch.removedBarcodes.length > 0) {
      this.selectedBatch.sampleBarcodes = this.selectedBatch.sampleBarcodes.filter(barcode => !barcodeMap.has(barcode));
      this.blocked = true;
      this.extractionService.removeSamples(this.selectedBatch).subscribe(
        result => {
          this.blocked = false;
          this.finalizeRemove();
          this.reloadOrders();
          this.reloadBatches();
          this.selectedBatch = result.data;
          this.selectedBatchBackup = this.clone(this.selectedBatch);
          this._messagesService.addSuccessMessage({severity: 'success', summary: 'All samples removed successfully from plate!'});
        },
        error => {
          this.handleError(error);
          this.selectedBatch.removedBarcodes = [];
          this.selectedBatch.sampleBarcodes = this.clone(this.selectedBatchBackup.sampleBarcodes);
        }
      );
    } else {
      this.finalizeRemove();
    }
  }

  finalizeRemove() {
    for(let key of this.removeTrackerMap.keys()) {
      this.plateSampleTracker.delete(this.plate.get(key).sampleBarcode);
      this.plate.delete(key);
    }
    this.cancelRemove();
  }

  cancelRemove() {
    this.removeTrackerMap = new Map<string, boolean>();
    this.removeOperationStarted = false;
    this.currentPosition = null;
    this.verticalOrientation = (this.selectedBatch.verticalOrientation == null || this.selectedBatch.verticalOrientation == undefined) ? true : this.selectedBatch.verticalOrientation;
    let positionalArray = this.verticalOrientation ? this.allPositionListVertical : this.allPositionListHorizontal;
    this.currentPosition = this.findNextEmptyPosition(positionalArray);
    if(this.currentPosition) {
      setTimeout(() => {
        document.getElementById("barcode-scan").focus();
      }, 50);
    }
  }

  saveCommentForSample(row: string, col: string, stepCommentOverlay: any) {
    let position = row + col;
    let commentUdpateRequest = {
      'labId': this.selectedLabId,
      'barcode': this.plate.get(position).sampleBarcode,
      'comments': this.commentStr
    }
    this.extractionService.commentSave(commentUdpateRequest).subscribe(
      _result => {
        this.plate.get(position).stepComment = this.commentStr;
        this.commentStr = null;
        stepCommentOverlay.hide();
        this._messagesService.addSuccessMessage({severity: 'success', summary: 'Comment saved!'});
      },
      error => { 
        this.handleError(error);
      }
    );
  }

  scanningDisabled() {
    return (!this.currentPosition || this.plate.has(this.currentPosition) || !this.selectedBatch || this.selectedBatch.status != this.BATCH_CREATED || this.removeOperationStarted || this.plate.size == 96);
  }

  commentSaveDisabled() {
    return !this.commentStr || this.commentStr == '';
  }

  getBorderColorStyle(row: string, col: string) {
    let styleObject = {};
    let position = row + col;

    if(position == this.currentPosition) {
      styleObject['background-color'] = '#B6F2C7'
    }
    if(this.removeTrackerMap.has(row + col)) {
        styleObject['border-color'] = 'red';
    } else {
      styleObject['border-color'] = '#016B96';
    }
    return styleObject;
  }

  saveScanDisabled() {
    return (!this.scanOperationStarted || this.plate.size == 0);
  }

  getSampleDetails(row: string, col: string): string {
    let position = row + col;
    if(this.plate.has(position)) {
      let sample = this.plate.get(position);
      return "Source: " + sample.sampleSource + '\n' + "Lib Type: " + sample.libraryType + '\n';
    } else {
      return null
    }
  }

  isPositionPopulated(row: string, col: string): boolean {
    let position = row + col;
    return !this.plate.has(position);
  }

  getCompletedTableData() {

    if(this.showExtractionCompletedBatches) {
      if(!this.scheduledFromDate && !this.scheduledToDate) {
        this.scheduledToDate = this.addDays(new Date(), 1);
        this.scheduledFromDate = this.addDays(this.scheduledToDate, -30);
      } else if(this.scheduledFromDate && !this.scheduledToDate) {
        this.scheduledToDate = this.addDays(this.scheduledFromDate, 30);
      } else if(!this.scheduledFromDate && this.scheduledToDate) {
        this.scheduledFromDate = this.addDays(this.scheduledToDate, -30);
      } else if(this.scheduledFromDate > this.scheduledToDate) {
        this.scheduledToDate = this.addDays(this.scheduledFromDate, 30);
      }

      this.batchTableLoading = true;

      let startDateStr = this.scheduledFromDate.toLocaleDateString("en-GB");
      let endDateStr = this.scheduledToDate.toLocaleDateString("en-GB");
      this.extractionService.getBatchesEligibleForExtraction(this.selectedLabId, 'EXTRACTION_COMPLETE', startDateStr, endDateStr).subscribe(
      results=>{
        this.batchTableLoading = false;
        this.batches = results.data;
      }, error =>{
        this.batchTableLoading = false;
        this.handleError(error);
      });
    } else {
      this.reloadBatches();
    }
    


  }

  getFirstOrderComment() {
    if(this.orderCommentsMap.size != 0) {
      return this.orderCommentsMap.entries().next().value;
    } else {
      return '';
    }
  }

  addDays(date: Date, days: number) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  getPlateSampleComment(row: string, col: string) {
    let position = row + col;
    return this.plate.has(position) ? this.plate.get(position).sampleComment : '';
  }
  
}
